import React, { useEffect, useState } from "react"
import { useParams, useHistory } from "react-router-dom"
import { ThemeProvider, CssBaseline } from "@material-ui/core"
import { createMuiTheme } from "@material-ui/core/styles"
import AdminSubscriptionDetailContainer from "../../containers/AdminContainer/AdminSubscriptionDetailContainer"
import services from "../../services"

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
})

function AdminSubscriptionDetailPage() {
  const { userId } = useParams()
  const history = useHistory()
  const [subscription, setSubscription] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        setLoading(true)
        setError(null)

        const response = await services.subscriptionAdminServices.getSubscriptionByUserId(
          userId,
        )

        if (response && response.data && response.data.data) {
          setSubscription(response.data.data)
        } else {
          setError("Subscription not found")
        }
      } catch (err) {
        console.error("Error fetching subscription:", err)
        setError(err.message || "Failed to load subscription")
      } finally {
        setLoading(false)
      }
    }

    if (userId) {
      fetchSubscription()
    }
  }, [userId])

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AdminSubscriptionDetailContainer
        subscription={subscription}
        loading={loading}
        error={error}
        onBack={() => history.goBack()}
      />
    </ThemeProvider>
  )
}

export default AdminSubscriptionDetailPage
